var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    codeGroupCd: "REGULATION_BILL_API_CD",
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "regulationBillCd",
                    label: "규제법규",
                  },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.regulationBillCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "regulationBillCd", $$v)
                    },
                    expression: "searchParam.regulationBillCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "규제항목 목록",
            tableId: "table",
            merge: _vm.grid.merge,
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            isExcelDown: false,
            isFullScreen: false,
            columnSetting: false,
            selection: _vm.popupParam.type,
            rowKey: "regulatedItemCd",
          },
          on: { rowDblclick: _vm.rowDblclick },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLSELECT", icon: "check" },
                        on: { btnClicked: _vm.select },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }